(function () {
    'use strict';

    angular.module('app')
        .factory('Pais', Pais);

    /* @ngInject */
    function Pais($resource) {
        return $resource('api/admin/pais/:id', {}, {
            'query': {
                method: 'GET',
                isArray: true,
                url: 'api/public/pais/query'
            },
            'get': {
                method: 'GET',
                url: 'api/public/pais/:id'
            },
            'findAll': {
                method: 'GET',
                isArray: true,
                url: 'api/public/pais/findAll'
            }
        });
    }
})();
